import {
    useState,
    useEffect,

} from "react"
import deleteAdditionalDocument from "./service"
import {
    getTitleFromOptions,
    obtainedFromOptions,
} from "../../../../helpers/additional-document-helper"
import Overlay from "../../../../Components/Overlay"
import { Trash, Eye } from 'lucide-react';
import DeleteConfirmationDialog from "./Components/DeleteConfirmationDialog";


export default function BGVSummaryDoc({ backgroundRequestId, role, data = {}, onRefresh }) {
    const [rows, setRows] = useState([])
    const [showOverlay, setShowOverlay] = useState(false)

    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false)
    const [selectedRowForDelete, setSelectedRowForDelete] = useState()

    useEffect(() => {
        const tempRows = []

        const filteredDocs =
            role === "HR"
                ? data?.additionalDocuments?.filter(doc => doc.obtainedFrom === "client")
                : data?.additionalDocuments;
        // Additional Documents
        filteredDocs?.forEach((doc) => {
            try {
                tempRows.push({
                    provider: doc.obtainedFromDescription || getTitleFromOptions(obtainedFromOptions, doc.obtainedFrom) || "",
                    name: doc?.fileName && doc?.fileExtension ? `${doc.fileName}.${doc.fileExtension}` : "",
                    description: doc.description,
                    isPartOfReport: doc?.appendToBgvReport !== undefined ? doc.appendToBgvReport : true,
                    key: doc?.key || "",
                    uploadedByName: doc?.uploadedByName || "",
                    documentId: doc?._id || "",
                })
            } catch (err) {
                console.warn("Error processing document row:", err)
                tempRows.push({
                    provider: "",
                    name: "",
                    description: "",
                    isPartOfReport: true,
                    key: "",
                    uploadedByName: "",
                    documentId: "",
                })
            }
        })


        setRows(tempRows)
    }, [data, role])


    const handleDownload = async (row) => {

        let url = encodeFilePath(row.key || row.url)

        if (url.startsWith("http")) {
            window.open(url, "_blank")
            return
        }
        if (url.startsWith("/")) {
            url = `${window.location.origin}${url}`
        } else {
            url = `${window.location.origin}/${url}`
        }
        window.open(url, "_blank")
    }


    const handleDelete = async (row) => {

        setSelectedRowForDelete(row)
        setIsDeleteDialogOpen(true)

    }

    return (

        <div className="p-4 overflow-x-auto">

            <table className="w-full min-w-[600px] border-collapse border border-gray-300 text-sm">
                <thead className="bg-gray-100">
                    <tr>
                        <th className="border border-gray-300 p-2 text-left">Source</th>
                        <th className="border border-gray-300 p-2 text-left">File Name</th>
                        <th className="border border-gray-300 p-2 text-left">Uploaded By</th>
                        <th className="border border-gray-300 p-2 text-left">Document Description</th>
                        <th className="border border-gray-300 p-2 text-center">Part of BGV report</th>
                        <th className="border border-gray-300 p-2 text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.length > 0 ? (
                        rows.map((row, idx) => (
                            <tr key={idx}>
                                <td className="border border-gray-300 p-2">{row.provider}</td>
                                <td
                                    className="border border-gray-300 p-2 max-w-[200px] overflow-hidden"
                                    title={row.name}
                                >
                                    {row.name}
                                </td>
                                <td
                                    className="border border-gray-300 p-2 truncate max-w-[200px]"
                                    title={row.uploadedByName}
                                >
                                    {row.uploadedByName}
                                </td>
                                <td className="border border-gray-300 p-2">{row.description}</td>
                                <td className="border border-gray-300 p-2 text-center">
                                    {row.isPartOfReport ? "Y" : "N"}
                                </td>
                                <td className="border border-gray-300 px-2 text-center">
                                    <div className="flex items-center justify-center">
                                        <button
                                            className="text-gray-600 hover:underline disabled:opacity-50"

                                            onClick={() => handleDownload(row)}
                                        >
                                            <Eye size={18} />
                                        </button>

                                        {role === "ADMIN" && (
                                            <button
                                                className="text-gray-600 px-3 py-1 rounded disabled:opacity-50"
                                                onClick={() => handleDelete(row)}
                                            >
                                                <Trash size={18} />
                                            </button>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td
                                colSpan="5"
                                className="border border-gray-300 p-2 text-center text-gray-500"
                            >
                                No data found
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <DeleteConfirmationDialog
                isOpen={isDeleteDialogOpen}
                onConfirm={async () => {

                    setIsDeleteDialogOpen(false)

                    const row = selectedRowForDelete
                    try {
                        setShowOverlay(true)

                        await deleteAdditionalDocument(backgroundRequestId, row.documentId) // call service
                        setRows((prev) => prev.filter((r) => r.key !== row.key))

                        if (onRefresh) onRefresh()
                    } catch (err) {
                        console.error("Delete failed:", err)
                        alert("Failed to delete document.")
                    } finally {
                        setShowOverlay(false)
                    }
                }}
                onClose={() => {
                    setIsDeleteDialogOpen(false)
                }}
            />

            {showOverlay && <Overlay />}
        </div>
    )
}

const encodeFilePath = (path) => {
    const parts = path.split('/')
    const filename = parts.pop()
    const encodedFilename = encodeURIComponent(filename)
    return [...parts, encodedFilename].join('/')
}
